module.exports = {"540226100":"卡嘎镇","540226101":"桑桑镇","540226200":"切热乡","540226201":"秋窝乡","540226202":"达居乡","540226203":"亚木乡","540226204":"贡久布乡","540226205":"达若乡","540226206":"措迈乡","540226207":"尼果乡","540226208":"孔隆乡","540226209":"如萨乡","540226210":"阿木雄乡","540226211":"查孜乡","540226212":"日吾其乡","540226213":"多白乡","540226214":"雄巴乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540226.json
// module id = 2497
// module chunks = 0